export default __webpack_public_path__ + "static/media/bell.3eea17ec.svg";